import React from "react";
import HoursItinerary from "./itinerary/HoursItinerary";
import OneDayItinerary from "./itinerary/OneDayItinerary";
import MultiDayItinerary from "./itinerary/MultiDayItinerary";

const ItineraryTrip = ({ trip, travelKeyToken ,  refreshTrip }) => {

const city = trip?.cities?.[0]?.cityName;
const days = trip?.cities?.[0]?.itineraryDays || [];
const startDate = trip?.cities?.[0]?.startDate;

if (!days.length) {
  return <p className="text-gray-500">No itinerary available</p>;
}

const tripType =
days.length <= 1 ? "day" :
days.length <= 8 ? "multi" :
"hours";

return (

<div className="space-y-10">

{tripType === "hours" && (

<HoursItinerary
data={{ days }}
city={city}
startDate={startDate}
editable={true}
travelKeyToken={travelKeyToken}
refreshTrip={refreshTrip}
/>

)}

{tripType === "day" && (

<OneDayItinerary
data={{ days }}
city={city}
startDate={startDate}
editable={true}
travelKeyToken={travelKeyToken}
refreshTrip={refreshTrip}
/>

)}

{tripType === "multi" && (

<MultiDayItinerary
data={{ days }}
city={city}
startDate={startDate}
editable={true}
travelKeyToken={travelKeyToken}
refreshTrip={refreshTrip}
/>

)}

</div>

);

};

export default ItineraryTrip;